import React, { useEffect } from 'react';
import "./ConfirmAdult.css";

function ConfirmAdultModal() {
  useEffect(() => {
    // クライアントサイドでのみ実行
    if (typeof window !== 'undefined') {
      const currentDate = new Date();
      try {
        const confirmAdultStr = localStorage.getItem("CONFIRM_ADULT");
        const confirmAdultObj = confirmAdultStr ? JSON.parse(confirmAdultStr) : false;
        const confirmAdultModal = document.getElementById("confirmAdult");

        if (confirmAdultObj && confirmAdultObj.isConfirm && confirmAdultObj.expired >= currentDate.getTime()) {
          // 確認済みの場合は非表示
          if (confirmAdultModal) {
            confirmAdultModal.style.display = "none";
          }
        } else {
          // 未確認の場合は表示
          if (confirmAdultModal) {
            confirmAdultModal.style.display = "flex";
          }
        }
      } catch (error) {
        console.error("Error checking adult confirmation:", error);
      }
    }
  }, []);

  // 確認ボタン押下時の処理
  const handleConfirmAdult = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    localStorage.setItem("CONFIRM_ADULT", JSON.stringify({ isConfirm: true, expired: d.getTime() }));

    // 直接DOMを操作してモーダルを非表示にする
    const confirmAdultModal = document.getElementById("confirmAdult");
    if (confirmAdultModal) {
      confirmAdultModal.style.display = "none";
    }
  };

  return (
    <div id="confirmAdult">
      <div className="confirmAdult-content">
        <h1 className="title">年齢確認</h1>
        <h2 className="sub-title">あなたは18歳以上ですか？</h2>
        <span className="text-content">この先はアダルトコンテンツを扱う<br />
        アダルトサイトになります</span>
        <span className="text-content-pc">この先はアダルトコンテンツを扱うアダルトサイトになります</span><br />
        18歳未満の方のアクセスは固くお断りします
        <div className="confirmAdult-action">
          <button className="confirm" onClick={handleConfirmAdult} >はい</button><br />
          <a href="https://www.yahoo.co.jp/">いいえ</a>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAdultModal;